import { c as _c } from "react/compiler-runtime";
import { useState, useRef, useEffect } from "react";
export const usePopupState = t0 => {
  const $ = _c(11);
  const delay = t0 === undefined ? 100 : t0;
  const [showPopup, setShowPopup] = useState(false);
  const containerRef = useRef(null);
  const timeoutRef = useRef(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
      setShowPopup(true);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleMouseEnter = t1;
  let t2;
  if ($[1] !== delay) {
    t2 = () => {
      timeoutRef.current = setTimeout(() => {
        setShowPopup(false);
      }, delay);
    };
    $[1] = delay;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleMouseLeave = t2;
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
    t4 = [];
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  useEffect(t3, t4);
  let t5;
  let t6;
  if ($[5] !== showPopup) {
    t5 = () => {
      const handleKeyDown = e => {
        if (e.key === "Escape" && showPopup) {
          setShowPopup(false);
        }
      };
      if (showPopup) {
        document?.addEventListener?.("keydown", handleKeyDown);
        return () => document?.removeEventListener?.("keydown", handleKeyDown);
      }
    };
    t6 = [showPopup];
    $[5] = showPopup;
    $[6] = t5;
    $[7] = t6;
  } else {
    t5 = $[6];
    t6 = $[7];
  }
  useEffect(t5, t6);
  let t7;
  if ($[8] !== handleMouseLeave || $[9] !== showPopup) {
    t7 = {
      showPopup,
      setShowPopup,
      containerRef,
      handleMouseEnter,
      handleMouseLeave
    };
    $[8] = handleMouseLeave;
    $[9] = showPopup;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
};